import React from 'react'

const IconGroups = ({ style }) => {
   return (
      <svg viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' style={style}>
         <circle cx='9' cy='8' r='3' />
         <path d='M4 20c0-3 2.2-5 5-5s5 2 5 5' />
         <circle cx='17' cy='9' r='2.3' />
         <path d='M14.5 20c0-2.5 1.4-4 3.5-4s3.3 1.2 3.6 3' />
      </svg>
   )
}
export default IconGroups
